const MAX_PLAUSIBLE_LCP_DURATION = 6e4;
function isValidLcpMetric(lcpValue) {
  return lcpValue != null && lcpValue > 0 && lcpValue <= MAX_PLAUSIBLE_LCP_DURATION;
}

export { MAX_PLAUSIBLE_LCP_DURATION, isValidLcpMetric };
//# sourceMappingURL=lcp.js.map
